import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { I18nContextProvider } from '@ecg-marktplaats/js-react-i18n';
import { Header } from '@hz-design-system/web-ui';
import type { THeaderConfig } from '@hz-design-system/web-ui/lib/types/THeaderConfig';
import { trackGAEvent } from '../../utils/gaTracking';

import '../../../scss/global.scss';

import UserReviewsApp from '../../apps/UserReviewsApp/UserReviewsApp';
import { TEnvironmentContext } from 'types/EnvironmentContext';

export default (i18n: any) => {
  const environment: TEnvironmentContext = window.__ENV_CONFIG__ || ({} as TEnvironmentContext);
  const userReviewsRoot = createRoot(document.getElementById('user-reviews-app-root')!);

  if (environment.isMyReviews) {
    const headerConfig: THeaderConfig = window.__HEADER_CONFIG__ || ({} as THeaderConfig);
    const headerContainer = document.getElementById('header-root');
    // Header is server side rendered in express-react library
    hydrateRoot(headerContainer!, <Header headerConfig={headerConfig} trackGAEvent={trackGAEvent} />);
  }
  userReviewsRoot.render(
    <I18nContextProvider i18nInstance={i18n}>
      <UserReviewsApp environment={environment} />
    </I18nContextProvider>,
  );
};
